/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import getList from "../../lib/api/getList";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import { useTranslation } from "react-i18next";
import TkOutSourcingPurchaseDetailCreateButton from "../input/TkOutSourcingPurchaseDetailCreateButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteSingleRecordButton from "../input/DeleteSingleRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
import { cloneDeep, debounce } from "lodash";

function TkOutSourcingPurchaseDetail(props) {
    const table = "TkOutSourcingPurchaseDetail";
    const view = "TkVwOutSourcingPurchaseDetail";

    const { id, onSelectMst, onDetailEmpty } = props;

    const { t } = useTranslation();

    const [tkOutSourcingPurchaseDetailSchema, setTkOutSourcingPurchaseDetailSchema] = useState();
    const [tkOutSourcingPurchaseDetailModifiedSchema, setTkOutSourcingPurchaseDetailModifiedSchema] = useState();
    const [tkOutSourcingPurchaseDetailGrid, setTkOutSourcingPurchaseDetailGrid] = useState();
    const [tkOutSourcingPurchaseDetailApi, setTkOutSourcingPurchaseDetailApi] = useState();
    const [tkOutSourcingPurchaseDetailData, setTkOutSourcingPurchaseDetailData] = useState();
    const [tkOutSourcingPurchaseDetailDataIsEmpty, setTkOutSourcingPurchaseDetailDataIsEmpty] = useState();
    const [tkOutSourcingPurchaseDetailSelect, setTkOutSourcingPurchaseDetailSelect] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setTkOutSourcingPurchaseDetailSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        (async () => {
            if (tkOutSourcingPurchaseDetailGrid) {
                tkOutSourcingPurchaseDetailGrid.selectionChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setTkOutSourcingPurchaseDetailSelect(grid.selectedItems[0]);
                        } else {
                            setTkOutSourcingPurchaseDetailSelect();
                        }
                    }),
                    10
                );

                tkOutSourcingPurchaseDetailGrid.itemsSourceChanged.addHandler(
                    debounce((grid, event) => {
                        if (grid.selectedItems && grid.selectedItems[0]) {
                            setTkOutSourcingPurchaseDetailSelect(grid.selectedItems[0]);
                        } else {
                            setTkOutSourcingPurchaseDetailSelect();
                        }
                    }),
                    10
                );
            }
        })();
    }, [tkOutSourcingPurchaseDetailGrid]);

    useEffect(() => {
        if (tkOutSourcingPurchaseDetailSchema) {
            (async () => {
                let modifiedSchema = cloneDeep(tkOutSourcingPurchaseDetailSchema);

                for (const column of modifiedSchema.columns) {
                    switch (column.name) {
                        case "startProcessCode":
                            column.disabled = true;

                            break;

                        case "endProcessCode":
                            column.disabled = true;

                            break;

                        default:
                            break;
                    }
                }

                setTkOutSourcingPurchaseDetailModifiedSchema(modifiedSchema);
            })();
        }
    }, [tkOutSourcingPurchaseDetailSchema]);

    useEffect(() => {
        if (tkOutSourcingPurchaseDetailApi) {
            tkOutSourcingPurchaseDetailApi.refresh();
        }
    }, [onSelectMst.outSourcingId]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onPartialFailure = (msg) => {
        notifyWarning(msg);
    };

    const onDialogUpdateDetail = () => {
        if (tkOutSourcingPurchaseDetailApi) {
            tkOutSourcingPurchaseDetailApi.refresh();
        }
    };

    const doHandleBackendErrorMsg = (reason) => {
        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;
    };

    return (
        <BasicCrudScreenType
            id={id}
            headerTitle={t("term.outSourcingPurchaseDetail")}
            table={table}
            view={view}
            onModifyViewUrl={(url) => `${url}/${onSelectMst.outSourcingId}`}
            onInitialized={(grid) => {
                grid.selectionMode = "Row";
                setTkOutSourcingPurchaseDetailGrid(grid);
            }}
            onApiInitialized={(api) => {
                setTkOutSourcingPurchaseDetailApi(api);
            }}
            onLoadData={(data) => {
                setTkOutSourcingPurchaseDetailData(data);

                const isEmpty = data.length < 1 ? true : false;

                setTkOutSourcingPurchaseDetailDataIsEmpty(isEmpty);
                onDetailEmpty(isEmpty);
            }}
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tkOutSourcingPurchaseDetailSchema && tkOutSourcingPurchaseDetailSchema.name}
                        accessMethod="POST"
                    >
                        <TkOutSourcingPurchaseDetailCreateButton
                            id={id}
                            schema={tkOutSourcingPurchaseDetailSchema}
                            refresh={tkOutSourcingPurchaseDetailApi}
                            disabled={onSelectMst?.approvalState}
                            onSuccess={onSuccess}
                            onSelectMst={onSelectMst}
                            customizeErrorMsgCallback={doHandleBackendErrorMsg}
                            onDialogUpdateDetail={onDialogUpdateDetail}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkOutSourcingPurchaseDetailSchema && tkOutSourcingPurchaseDetailSchema.name}
                        accessMethod={
                            tkOutSourcingPurchaseDetailSchema &&
                            (tkOutSourcingPurchaseDetailSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <UpdateRecordButton
                            id={id}
                            schema={tkOutSourcingPurchaseDetailModifiedSchema}
                            grid={tkOutSourcingPurchaseDetailGrid}
                            refresh={tkOutSourcingPurchaseDetailApi}
                            disabled={
                                onSelectMst?.approvalState ||
                                tkOutSourcingPurchaseDetailDataIsEmpty ||
                                !tkOutSourcingPurchaseDetailSchema
                            }
                            //disabled={tkOutSourcingPurchaseDetailDataIsEmpty || !tkOutSourcingPurchaseDetailSchema}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkOutSourcingPurchaseDetailSchema && tkOutSourcingPurchaseDetailSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteSingleRecordButton
                            id={id}
                            schema={tkOutSourcingPurchaseDetailSchema}
                            grid={tkOutSourcingPurchaseDetailGrid}
                            refresh={tkOutSourcingPurchaseDetailApi}
                            makeItemName={(row) => {
                                return `${t("columnName.outSourcingDetailId")}: ${row.outSourcingDetailId}`;
                            }}
                            color="secondary"
                            disabled={onSelectMst?.approvalState || tkOutSourcingPurchaseDetailDataIsEmpty}
                            //disabled={tkOutSourcingPurchaseDetailDataIsEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onPartialFailure}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkOutSourcingPurchaseDetailSchema && tkOutSourcingPurchaseDetailSchema.name}
                        accessMethod="SAVETOEXCEL"
                    >
                        <SaveToExcelButton
                            id={id}
                            grid={tkOutSourcingPurchaseDetailGrid}
                            view={view}
                            color="primary"
                            disabled={tkOutSourcingPurchaseDetailDataIsEmpty}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
            noCreate
            noEdit
            noDelete
            noExcel
        />
    );
}

export default TkOutSourcingPurchaseDetail;
